"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionForm = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var styles = __importStar(require("./AutomationsForm.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var lodash_2 = require("lodash");
var MultiAcceptorForm_1 = require("./MultiAcceptorForm");
var ActionForm = function (props) {
    var selectedAction = props.selectedAction, selectedActionIndex = props.selectedActionIndex, selectFieldOption = props.selectFieldOption, integrationTargetDisplayName = props.integrationTargetDisplayName;
    var MaybeWithTooltip = function (_a) {
        var show = _a.show, children = _a.children, _b = _a.tooltipMessage, tooltipMessage = _b === void 0 ? "" : _b;
        if (show) {
            return (react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, content: tooltipMessage, size: kaleidoscope_1.TooltipSize.Large }, children));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    };
    var FormField = function (_a) {
        var formField = _a.formField, isDisabled = _a.isDisabled, disabledMessage = _a.disabledMessage, errorMessage = _a.errorMessage;
        return (react_1.default.createElement("div", { className: styles.formComponent, key: formField.name },
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.formLabel }, (0, lodash_2.capitalize)(formField.label)),
            react_1.default.createElement(MaybeWithTooltip, { show: !!isDisabled && !!disabledMessage, tooltipMessage: disabledMessage },
                react_1.default.createElement(kaleidoscope_1.Select, { disabled: !!isDisabled, label: "Select a field", placeholder: "Select ".concat(formField.label), value: selectedAction.selectedOptions[formField.name], labelHidden: true, autoStack: true, onChange: lodash_1.noop, error: errorMessage }, formField.options.map(function (option, key) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: key, value: option.id, onClick: function () { return selectFieldOption(selectedActionIndex, formField, option); } }, option.label)); })))));
    };
    var getErrorMessage = function (field) {
        var _a, _b;
        return ((_a = selectedAction.selectedOptions) === null || _a === void 0 ? void 0 : _a[field.name]) &&
            !field.options.map(function (option) { return option.id; }).includes((_b = selectedAction.selectedOptions) === null || _b === void 0 ? void 0 : _b[field.name])
            ? "No longer exists in ".concat(integrationTargetDisplayName)
            : undefined;
    };
    var preSelectOption = function (field) {
        field.options.length === 1 && selectFieldOption(selectedActionIndex, field, field.options[0]);
    };
    var fields = [];
    if (selectedAction && selectedAction.form)
        selectedAction.form.map(function (field) {
            var _a;
            preSelectOption(field);
            var errorMessage = getErrorMessage(field);
            switch (field.type) {
                case "dropdown":
                    fields.push(react_1.default.createElement(FormField, { formField: field, errorMessage: errorMessage }));
                    if (field.hasSubField) {
                        var selectedOptionId_1 = (_a = selectedAction.selectedOptions) === null || _a === void 0 ? void 0 : _a[field.name];
                        var selectedOption = field.options.find(function (option) { return option.id === selectedOptionId_1; });
                        if (!!selectedOptionId_1 && !!selectedOption) {
                            var subfieldErrorMessage = errorMessage ? undefined : getErrorMessage(selectedOption.subField);
                            fields.push(react_1.default.createElement(FormField, { formField: selectedOption.subField, errorMessage: subfieldErrorMessage }));
                        }
                        else {
                            fields.push(react_1.default.createElement(FormField, { formField: field.options[0].subField, isDisabled: true, disabledMessage: "Select ".concat(field.label, " first") }));
                        }
                    }
                    break;
                case "customFormsTable":
                    var customFormFieldSelected = selectedAction.selectedOptions && !!selectedAction.selectedOptions[field.name];
                    fields.push(react_1.default.createElement("div", { className: styles.customFormWrapper },
                        react_1.default.createElement(FormField, { formField: field, errorMessage: errorMessage }),
                        customFormFieldSelected && react_1.default.createElement(MultiAcceptorForm_1.MultiAcceptorForm, null)));
                    break;
            }
        });
    return (react_1.default.createElement("div", { className: styles.actionForm },
        react_1.default.createElement("div", { className: styles.fieldWrapper }, fields)));
};
exports.ActionForm = ActionForm;
